export const COMPLIANT = 'Compliant';
export const NON_COMPLIANT = 'Non-compliant';
export const NEW = 'New';
export const PENDING = 'Pending';
